export default __webpack_public_path__ + "static/media/notetaker.d5ae3af8.gif";